import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { isHomeLeaseSwitcherEnabled } from "src/helpers/helperLease";

import {
  LandingScreen,
  AccountSearchScreen,
  AccountRegisterSreen,
  UnVerifiedEmailScreen,
  VerifiedEmailScreen,
  //__
  SettingsScreen,
  SettingLanguagesScreen,
  SettingsAccountInfoScreen,
  //__
  RequestsLandingScreen,
  MaintainanceRequestCreateScreen,
  MaintainanceRequestDetailsScreen,
  MaintainanceRequestListsScreen,
  MoveInConditionCreateScreen,
  // __
  RentLandingScreen,
  RentLinkedAccountsListScreen,
  RentLinkedAccountsCreateBankScreen,
  RentLinkedAccountsCreateCardScreen,
  RentActivityListScreen,
  RentPaymentScreen,
  RentReportingInfoScreen,
  RentReportingConfirmationScreen,
  RentReportingHomeScreen,
  RentReportingListScreen,
  // __
  Error401Screen,
  Error404Screen,
  Error404ApiScreen,
  PropertyInactiveScreen,
  // __
  HomeScreen,
  RenewalChoiceScreen,
  RenewalTermsScreen,
  RenewalTermSelectedStubScreen,
  RenewalNtvScreen,
  // __
  PropertyLandingScreen,
} from "../pages";
import PrivateRoute from "./PrivateRoute";
import { RegisterProspectScreen } from "../pages/Account/Register/RegisterProspect";
import { LeaseApplication } from "../pages/Account/Register/LeaseApplication";
import { LeasePayment } from "../pages/Account/Register/LeasePayment";
import AuthResume from "../pages/Auth/AuthResume";
import { IncomeVerification } from "../pages/Lease/IncomeVerification";
import { SettingsQuestionScreen } from "../pages/Settings/Question";
import { SettingsLeasesScreen } from "../pages/Settings/Leases";
import Docs from "../pages/Settings/Docs";
import { useAuth0 } from "@auth0/auth0-react";
import { ManualLoader } from "../components";
import { ApplicationsListScreen } from "../pages/Home/ApplicationList";
import { AffordablePrequalifyScreen } from "../pages/Application/AffordablePrequalify";
import { AffordableApplication } from "../pages/Application/Affordable/AffordableApplication";
import { CoApplicantApplication } from "../pages/Application/Affordable/CoApplicantApplication";
import { LiveInAideApplication } from "../pages/Application/Affordable/LiveInAideApplication";
import { AvailabilityScreen } from "../pages/Availability/AvailabilityScreen";
import { UnitDetailScreen } from "../pages/Availability/components/UnitDetailScreen";

function LeaseSwitcherRoute() {
  const { tpHomeLeaseSwitcher } = useFlags();
  if (!isHomeLeaseSwitcherEnabled(tpHomeLeaseSwitcher)) {
    return <Navigate to="/settings" replace />;
  }
  return <SettingsLeasesScreen />;
}

function FromResmanScreen() {
  const { isAuthenticated, isLoading } = useAuth0();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const url = query.get("url");
  const urlObj = new URL(url!);
  const segments = urlObj.pathname.split("/");
  const abbreviationCode = segments[segments.length - 1];
  return (
    <>
      {isLoading && <ManualLoader />}
      {isAuthenticated && !isLoading && <Navigate to="/" />}
      {!isAuthenticated && !isLoading && (
        <Navigate to={`/property/${abbreviationCode}`} />
      )}
    </>
  );
}

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/from-resman" element={<FromResmanScreen />} />
      <Route path="/" element={<LandingScreen />} />
      <Route path="/invitation" element={<AccountSearchScreen />} />
      <Route
        path="/invitation/:invitationId"
        element={<AccountSearchScreen />}
      />
      <Route path="/unverified-email" element={<UnVerifiedEmailScreen />} />
      <Route path="/verified-email" element={<VerifiedEmailScreen />} />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/register" element={<AccountRegisterSreen />} />
      </Route>
      {/**-----*/}
      <Route path="*" element={<Error404Screen />} />
      <Route path="/error/401" element={<Error401Screen />} />
      <Route path="/error/api/404" element={<Error404ApiScreen />} />
      <Route
        path="/error/property-inactive"
        element={<PropertyInactiveScreen />}
      />

      {/**-----*/}
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/settings/leases" element={<LeaseSwitcherRoute />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/settings/languages"
          element={<SettingLanguagesScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/settings/account-info"
          element={<SettingsAccountInfoScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/settings/question" element={<SettingsQuestionScreen />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/settings/docs" element={<Docs />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/settings/applications"
          element={<ApplicationsListScreen />}
        />
      </Route>
      {/**-----*/}
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/requests" element={<RequestsLandingScreen />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/requests/maintenance/create"
          element={<MaintainanceRequestCreateScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/requests/maintenance/list"
          element={<MaintainanceRequestListsScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/requests/maintenance/detail/:id"
          element={<MaintainanceRequestDetailsScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/requests/move-in-condition"
          element={<MoveInConditionCreateScreen />}
        />
      </Route>
      {/**-----*/}
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/rent" element={<RentLandingScreen />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/linked-accounts"
          element={<RentLinkedAccountsListScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/create/bank-account"
          element={<RentLinkedAccountsCreateBankScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/create/card"
          element={<RentLinkedAccountsCreateCardScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/activity/list"
          element={<RentActivityListScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/rent/payment" element={<RentPaymentScreen />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/reporting/info"
          element={<RentReportingInfoScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/reporting/confirmation"
          element={<RentReportingConfirmationScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/reporting/home"
          element={<RentReportingHomeScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/rent/reporting/list"
          element={<RentReportingListScreen />}
        />
      </Route>

      {/**-----*/}
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/home" element={<HomeScreen />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/renewal" element={<RenewalChoiceScreen />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/renewal/renew" element={<RenewalTermsScreen />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/renewal/renew/next"
          element={<RenewalTermSelectedStubScreen />}
        />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/renewal/move-out" element={<RenewalNtvScreen />} />
      </Route>
      {/**-----*/}
      <Route
        path="/property/:abbreviationCode"
        element={<PropertyLandingScreen />}
      />
      <Route
        path="/availability/:propertyCode"
        element={<AvailabilityScreen />}
      />
      <Route
        path="/availability/:propertyCode/units/:unitNumber"
        element={<UnitDetailScreen />}
      />
      {/**---application routes---*/}
      {/* Prequalify is public (publicApi only). Authenticated affordable wizards
          sit under PrivateRoute so a dead memory token cache soft-recovers with
          returnTo — same path as conventional /application/form. */}
      <Route
        path="/application/affordable/prequalify"
        element={<AffordablePrequalifyScreen />}
      />
      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/application/affordable/form"
          element={<AffordableApplication />}
        />
        <Route
          path="/application/affordable/co-applicant"
          element={<CoApplicantApplication />}
        />
        <Route
          path="/application/affordable/live-in-aide"
          element={<LiveInAideApplication />}
        />
      </Route>
      <Route
        path="/application/register"
        element={<RegisterProspectScreen />}
      />
      <Route path="/application" element={<LandingScreen />} />
      <Route path="/application" element={<PrivateRoute />}>
        <Route path="/application/list" element={<ApplicationsListScreen />} />
        <Route path="/application/form" element={<LeaseApplication />} />
        <Route
          path="/application/income-verification"
          element={<IncomeVerification />}
        />
        <Route path="/application/payment" element={<LeasePayment />} />
      </Route>
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/auth/resume" element={<AuthResume />} />
      </Route>
    </Routes>
  );
};
